export default {
	sec_10: {
		title: {
			one: 'JP WORLD Pay ',
			two: '가맹점 등록',
		},
		desc: {
			one: '고객이 지불한 페이는',
			two: '등록된 가맹점 별로 정산',
		},
		btn: {
			one: '회원가입하기',
			two: '앱 다운로드',
		},
	},
	sec_11: {
		one: {
			title: {
				one: '가맹점이 많아도',
				two: '한번에 전체 정산',
			},
			desc: {
				one: '품목별까지 꼼꼼하게 놓치지 않고 정산됩니다.',
			},
		},
		two: {
			title: {
				one: '언제든지 원하는 방식으로 지불',
			},
			desc: {
				one: '암호화폐로 지불할 수 있고 원하는 통화쌍으로 지불이 가능합니다.',
			},
		},
	},
};
